import React, { useState } from 'react';

import { List, Datagrid, TextField, SelectInput, TextInput, Button, TopToolbar, FormDataConsumer, required, NumberInput, BooleanInput, FunctionField, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, SaveButton, useNotify, useRedirect, Filter, downloadCSV, NumberField, useDataProvider, RadioButtonGroupInput, useUpdate, DateTimeInput } from 'react-admin';import { useEffect } from 'react';

import jsonExport from 'jsonexport/dist';

import {useHistory} from 'react-router-dom';
import { useTranslate  } from '../common/language';

import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import CloseIcon from '@mui/icons-material/Close';


import { green, orange, red } from '@mui/material/colors';import { TextFieldShow } from '../components/TextFieldShow';
import { headersAPIObjectAuth } from '../common/utils';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { modules, modulesOptions, targetsEmails, emailsStatus, apiUrl, choicesTypeUser, choicesDonationsUsersPaymentMethod, choicesDonationsUsersPublicPaymentMethod, choicesDonationsUsersStatus } from './../common/constants';import { subscriptionModule, DateTimeField, dateAndTimeToCatalan, DatagridNoResults } from './../common/utils';  

import { ExportButton } from './../components/ExportButton';
import { BackLink } from './../components/BackLink';

import { SendEmailIconStatus } from './../components/Emails';
import DownloadIcon from '@material-ui/icons/GetApp';

import { RenderBoolean, UserFullNameTxt } from '../components/User';
import Tooltip from '@mui/material/Tooltip';

import { validateMaxLength, validateEmail, validateDoubleGreatZero } from './../components/Validator';export const DonationsUsersList = (props) => {
  const translate = useTranslate();  
  const history = useHistory();
  const [info, setInfo] = useState();
  const dataProvider = useDataProvider();
    
  let current_path = history && history.location && history.location.pathname ? history.location.pathname : '';
    
  let basePath='/donations_users'; 
  let resource = 'donations_users';
  let strRedirect = 'donations_users';
    
  let donations_projects_id = 0;
  if (props.match.params.id) donations_projects_id = props.match.params.id;
  
  let report = 0;
  if (current_path.includes('/reports')) report = 1;
  
  let year = 0;
  if (props.match.params.year) year = props.match.params.year;
  
  let backLink = '/donations_projects';
  backLink = report ? '/reports' + backLink : backLink;
      
  useEffect(() => {
    
    if (donations_projects_id > 0)
    {
      dataProvider.getOne('donations_projects', { id: donations_projects_id, report: report, associations_id: localStorage.getItem('associations_id') })
      .then(({ data }) => {     
        setInfo(data);
      })
      .catch(error => {           
      });
    }
       
  }, []);
  
  let page_transfer_validations = current_path.includes('/donations_transfer_validations');
  let page_donations_project = current_path.includes('/donations_users');
  let page_donations_project_fac = current_path.includes('/reports/donations_users');
  
  let is_fac = subscriptionModule(modules.FEDERATION);
  let is_donation_own = subscriptionModule(modules.DONATIONS,modulesOptions.DONATIONS_OWN );
  let is_donation_fac = subscriptionModule(modules.DONATIONS,modulesOptions.DONATIONS_FAC );
  
  let can_create_donations = donations_projects_id && (is_fac || is_donation_own);  
  let can_go_back = page_donations_project || page_donations_project_fac;
  const editParams = new URLSearchParams(history.location.search);
  const editDonationId = editParams.get('edit');
  const model182Edit = editParams.get('model182') === '1';
  
  return (
    <>   
    { can_go_back ? <BackLink link={backLink} title={ info ? info.name : null } /> : null }
    {editDonationId ? <DonationEditFromUrl donations_users_id={editDonationId}
      donations_projects_id={donations_projects_id} forceFiscalData={model182Edit} /> : null}
    <ResourceContextProvider value={resource}>
      <List 
        basePath={basePath}   
        filter={{ report: report, associations_id: localStorage.getItem('associations_id'), donations_projects_id : donations_projects_id, only_transfer: page_transfer_validations }}  
        actions={ <ListActions create={can_create_donations} donations_projects_id={donations_projects_id} report={report} />}    
        bulkActionButtons={false}          
        perPage={1000}   
        pagination={false}
        sort={{ field: 'dateTime', order: 'DESC' }} 
        label=""  
        title=""  
        resource={resource}
        filters={ <MyFilter /> } 
        filterDefaultValues={ { q: "", only_accepted: !page_transfer_validations, only_pending: page_transfer_validations }}
        
      >        
        <Datagrid           
          expand={<DonationsUsersDetails />} 
          empty={ <DatagridNoResults /> } >  
          <FunctionField label={translate('donations_users.order_id')} render={record => getOrderId(record.id) } sortable={false} />
          <FunctionField label={translate('donations_users.donations_users_rel')} render={record => getOrderId(record.donations_users_rel) } sortable={false} />
          <DateTimeField source="date_time" label={translate('donations_users.date_time')} sortable={false} /> 
          <TextField source="complete_name" label={translate('common.name')} sortable={false} /> 
          <TextField source="email" label={translate('donations_users.email')} sortable={false} />  
          <TextField source="nif" label={translate('donations_users.nif')} sortable={false} />            
          <NumberField source="amount" label={translate('donations_users.amount')} sortable={false} locales="es-ES" options={{ style: 'currency', currency: 'EUR' }} /> 
          
          { !page_transfer_validations ?
          <FunctionField render={record => translate('donations_users.payment_method_' + record.payment_method) } label={translate('donations_users.payment_method')}  sortable={false}  />
          : null}
          
          <FunctionField label={translate('donations_users.status')} render={record => <RenderStatus status={record.status} /> } sortable={false}  />          
          
          { page_donations_project || page_donations_project_fac ? 
            <FunctionField label={translate('donations_users.email_sent_confirmation_title')} render={record => 
            page_donations_project_fac && record.donations_projects_payment_systems_fac || 
            page_donations_project && !record.donations_projects_payment_systems_fac ?
              <SendEmailIconStatus record={record} target={targetsEmails.DONATIONS_USERS_CONFIRMATION}  /> 
            : null
            } />
          : null }
                    
          <FunctionField label={translate('donations_users.actions')} render={record => 
            page_donations_project_fac && record.donations_projects_payment_systems_fac || 
            page_donations_project && !record.donations_projects_payment_systems_fac ||
            page_transfer_validations ?
            <>
            <EditDonationButton record={record} donations_projects_id={donations_projects_id} />
            { (page_transfer_validations || page_donations_project_fac || page_donations_project) && record.status == 1 && !record.donations_users_rel && record.payment_method === 0? <ConfirmButton record={record} periodical={true} /> : null }
            { (page_transfer_validations || page_donations_project_fac || page_donations_project) && !record.status == 1 ? <ConfirmButton record={record} periodical={false} /> : null }            
            </> 
            : null
          } sortable={false}  />
          
        </Datagrid>        
      </List>
    </ResourceContextProvider>
    </>
  );
};

const DonationEditFromUrl = ({ donations_users_id, donations_projects_id, forceFiscalData }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [record, setRecord] = useState();

  useEffect(() => {
    let mounted = true;
    dataProvider.getOne('donations_users', { id: donations_users_id })
      .then(({ data }) => {
        if (mounted) setRecord({ ...data,
          donations_projects_payment_systems_fac: data.payment_systems_fac });
      })
      .catch(error => notify(error.message, 'error'));
    return () => { mounted = false; };
  }, [dataProvider, donations_users_id, notify]);

  const handleClose = () => history.replace(history.location.pathname);
  return record ? <EditDonationButton record={record}
    donations_projects_id={donations_projects_id}
    forceFiscalData={forceFiscalData} openInitially hideTrigger onClose={handleClose} /> : null;
};

export const getOrderId = (id) => id ? 'D-' + id.toString().padStart(8, '0') : '';

const RenderStatus = (props) => {
    const translate = useTranslate(); 

    if (props.status === 0) 
        return <Tooltip title={translate('donations_users.status_0')}>
            <Avatar sx={{ bgcolor: orange[500] , width: 30, height: 30 }} ><PendingActionsIcon /></Avatar>
        </Tooltip>;
    else if (props.status === 1) 
        return <Tooltip title={translate('donations_users.status_1')}>
                <Avatar sx={{ bgcolor: green[500] , width: 30, height: 30 }} ><DoneIcon /></Avatar>
        </Tooltip>;
    else if (props.status === 2)
        return <Tooltip title={translate('donations_users.status_2')}>
            <Avatar sx={{ bgcolor: red[500] , width: 30, height: 30 }} ><CloseIcon /></Avatar>
        </Tooltip>;
    else
        return null;
}

export const ConfirmButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('donations_users/' + localStorage.getItem('associations_id') + '/' + props.record.id + '/confirm/' + props.periodical );
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
  const dataProvider = useDataProvider();
  
  const today = new Date();
          
  const handleClick = () => {        
    setShowDialog(true);        
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };
  
  let title = props.periodical ? translate('donations_users.copy_title') : translate('donations_users.validate_transfer');
    
  return (
    <>            
      <Button onClick={handleClick} label={props.periodical ? translate('donations_users.copy') : translate('donations_users.validate')} className="">
        { props.periodical ? <ContentCopyIcon />: <DoneIcon />}
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('donations_users.validate_transfer')}
      >
        <DialogTitle>{ title + ' ' + getOrderId(props.record.id)} </DialogTitle>

        <FormWithRedirect
          save={handleSubmit}
          initialValues={{ associations_id : localStorage.getItem('associations_id'), donations_users_id : props.record.id, status: 1, send_confirmation: true, amount: props.record.amount }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <FormDataConsumer>
                {({ formData, ...rest }) => 
                <Grid container spacing={2}>
                  <Grid item xs={4}>     
                    <DateTimeInput fullWidth source="date_time" label={translate('donations_users.date_time')} validate={[required()]} initialValue={today} />   
                  </Grid>
                  <Grid item xs={4}>                    
                    <NumberInput source="amount" label={translate('donations_users.amount')} parse={value => value ? value : 0 } validate={[required(),validateDoubleGreatZero(translate('common.validation.number'))]} />            
                  </Grid>
                  <Grid item xs={4}> 
                    <SelectInput fullWidth label={translate('donations_users.status')} source="status" choices={choicesDonationsUsersStatus(translate)} validate={[required()]} />
                  </Grid>                   
                  <Grid item xs={12}>                                               
                    {formData.status == 1 ? 
                    <BooleanInput fullWidth source="send_confirmation" label={translate('donations_users.send_confirmation')} />
                    : null }
                  </Grid>
                </Grid>
                }
                </FormDataConsumer>
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

export const DownloadCertificate = ({ record, donations_users_id, ...props}) => {
    
  const translate = useTranslate(); 
  const notify = useNotify();

  const handleAction = async () => {

    const result = await fetch(apiUrl + '/donations_users/' + donations_users_id + '/certificate/' + localStorage.getItem('associations_id'), { 
      headers: headersAPIObjectAuth()
    });
    
    const blob = await result.blob();
    const href = window.URL.createObjectURL(blob);
    
    var tempLink = document.createElement('a');
    tempLink.href = href;
    tempLink.setAttribute('download', translate('donations_users.pdf_certificate_filename'));
    tempLink.click();
    
    notify(translate('donations_users.pdf_certificate_ok'),"success");
  };
  
  return (
    <Tooltip title={translate('donations_users.pdf_download')}> 
      <DownloadIcon onClick={handleAction} />
    </Tooltip>
  );

};


const MyFilter = (props) => {
    const translate = useTranslate(); 
    const history = useHistory();
    
    let current_path = history && history.location && history.location.pathname ? history.location.pathname : '';
    
    return (
    <Filter {...props}>         
        <TextInput label={translate('common.search')} source="q" alwaysOn validate={[validateMaxLength(50,translate('common.validation.maxLength'))]} resettable /> 
        { !current_path.includes('/donations_transfer_validations') ? <BooleanInput label={translate('donations_users.only_accepted')} source="only_accepted" alwaysOn /> : null }
        { current_path.includes('/donations_transfer_validations') ? <BooleanInput label={translate('donations_users.only_pending')} source="only_pending" alwaysOn /> : null }
    </Filter>
);
};

export const DonationsUsersDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
        
  return (
    <div className="usersClassroomsExpand">        
      <Grid container spacing={2}>
        <Grid item xs={3}>   
          <TextFieldShow source={dateAndTimeToCatalan(record.date_time, translate)} label={translate('donations_users.date_time')} />
        </Grid>
        <Grid item xs={3}>   
          <TextFieldShow source={record.donations_projects_name} label={translate('donations_users.donations_projects_name')} />
        </Grid>
        <Grid item xs={3}>   
          <TextFieldShow source={record.associations_name} label={translate('donations_users.associations_name')} />
        </Grid>
        <Grid item xs={3}>   
          <TextFieldShow source={record.amount} label={translate('donations_users.amount')} />
        </Grid>        
        <Grid item xs={3}>   
          <TextFieldShow source={<UserFullNameTxt record={record} />} label={translate('donations_users.first_name')} />
        </Grid> 
        <Grid item xs={3}>   
          <TextFieldShow source={record.email} label={translate('donations_users.email')} />
        </Grid> 
        <Grid item xs={3}>   
          <TextFieldShow source={record.phone} label={translate('donations_users.phone')} />
        </Grid> 
        <Grid item xs={3}>   
          <TextFieldShow source={record.nif} label={translate('donations_users.nif')} />
        </Grid>    
        <Grid item xs={3}>   
          <TextFieldShow source={record.address} label={translate('donations_users.address')} />
        </Grid> 
        <Grid item xs={3}>   
          <TextFieldShow source={record.zip} label={translate('donations_users.zip')} />
        </Grid> 
        <Grid item xs={3}>   
          <TextFieldShow source={record.city} label={translate('donations_users.city')} />
        </Grid> 
        <Grid item xs={3}>   
          <TextFieldShow source={record.country} label={translate('donations_users.country')} />
        </Grid>         
        <Grid item xs={3}>   
          <TextFieldShow source={translate('donations_users.payment_method_'+record.payment_method)} label={translate('donations_users.payment_method')} />
        </Grid>         
        {record.payment_method == 2 ?
        <Grid item xs={3}>   
          <TextFieldShow source={record.transaction_id} label={translate('donations_users.transaction_id')} />
        </Grid> : <Grid item xs={3}></Grid> }
        <Grid item xs={3}>   
          <TextFieldShow source={translate('donations_users.status_' + record.status)} label={translate('donations_users.status')} />
        </Grid>  
        <Grid item xs={3}>
            <TextFieldShow source={<RenderBoolean source={record.want_certificate} />} label={translate('donations_users.want_certificate')} />   
        </Grid>
        <Grid item xs={12}>   
          <TextFieldShow source={record.comment} label={translate('donations_users.comment')} />
        </Grid>         
      </Grid>
      
    </div>
  );
};

const exporter = (items, translate, notify) => {
    
  const itemsForExport = items.map(item => {
    var itemForExport = {
        id: getOrderId(item.id),
        donations_users_rel: getOrderId(item.donations_users_rel),
        date_time: item.date_time,
        donations_projects_id: item.donations_projects_id,
        donations_projects_name: item.donations_projects_name,
        associations_id: item.associations_id,
        associations_name: item.associations_name,
        user_type: translate('users.user_type_' + item.user_type),
        first_name: item.first_name,
        last_name_1: item.last_name_1,
        last_name_2: item.last_name_2,
        email: item.email,
        want_certificate: item.want_certificate,
        nif: item.nif,
        address: item.address,
        zip: item.zip,
        city: item.city,
        country: item.country,
        phone: item.phone,
        payment_method: translate('donations_users.payment_method_' + item.payment_method),        
        amount: item.amount != null ? item.amount.toFixed(2).replace('.', ',') : '',    
        status: translate('donations_users.status_'+item.status),
        transaction_id: item.transaction_id,
        comment: item.comment,        
        confirmation_status: item.confirmation_status == emailsStatus.SENT_TO_SMTP_OK ? 'Sí' : 'No',
        confirmation_date_time: item.confirmation_date_time,
        send_status: item.send_status == emailsStatus.SENT_TO_SMTP_OK ? 'Sí' : 'No',
        send_date_time: item.send_date_time
    };
    return itemForExport;
  });
  jsonExport(itemsForExport, {
    headers: ['id',
        'donations_users_rel',
        'date_time',
        'donations_projects_id',
        'donations_projects_name',
        'associations_id',
        'associations_name'
,'user_type'
,'first_name'
,'last_name_1'
,'last_name_2'
,'email'
,'want_certificate'
,'nif'
,'address'
,'zip'
,'city'
,'country'
,'phone'
,'payment_method'
,'amount'
,'status'
,'transaction_id'
,'comment'
,'confirmation_status'
,'confirmation_date_time'
,'send_status'
,'send_date_time'
],
    rename: [translate('common.id'),translate('donations_users.donations_users_rel'), translate('donations_users.date_time'), translate('donations_users.donations_projects_id'),translate('donations_users.donations_projects_name'),
        translate('donations_users.associations_id'), translate('donations_users.associations_name'), 
        translate('donations_users.user_type'),translate('donations_users.first_name'),translate('donations_users.last_name_1'),
        translate('donations_users.last_name_2'),translate('donations_users.email'),translate('donations_users.want_certificate'),
        translate('donations_users.nif'),translate('donations_users.address'),
        translate('donations_users.zip'),translate('donations_users.city'),translate('donations_users.country'),translate('donations_users.phone'),
        translate('donations_users.payment_method'),translate('donations_users.amount'),translate('donations_users.status'),
        translate('donations_users.transaction_id'),translate('donations_users.comment'), 
        translate('donations_users.confirmation_status'), translate('donations_users.confirmation_date_time'), translate('donations_users.send_status'), translate('donations_users.send_date_time') ],        
        
  }, (err, csv) => {
    const csv_new = '\uFEFF' + csv;
    downloadCSV(csv_new, translate('donations_users.exporter_file_name') ); 
    notify(translate('common.download_ok'),"success");
  });
};


const ListActions = (props) => {
    const translate = useTranslate(); 
    const history = useHistory();
    
    let current_path = history && history.location && history.location.pathname ? history.location.pathname : '';
        
    let filterExport = { 
        associations_id: localStorage.getItem('associations_id'),    
        year: props.year ? props.year : 0,
        q: props.filterValues && props.filterValues.q ? props.filterValues.q : '',
        only_accepted: props.filterValues && props.filterValues.only_accepted ? props.filterValues.only_accepted : false,
        only_pending: props.filterValues && props.filterValues.only_pending ? props.filterValues.only_pending : false,
        only_transfer: current_path.includes('/donations_transfer_validations') ? true : false,
        only_certificate_not_sent: props.filterValues && props.filterValues.only_certificate_not_sent ? props.filterValues.only_certificate_not_sent : false,
        donations_projects_id: props.donations_projects_id,
        report : props.report
    };
    
    return (
    <TopToolbar>  
        { props.create ? <CreateDonationButton {...props} /> : null }   
        <ExportButton maxResults="1000000" filterValues={filterExport} alwaysEnabled={false} exporter={exporter} sort={{ field: 'dateTime', order: 'DESC' }} /> 
    </TopToolbar>
    );
};
               
export const EditDonationButton = ({ ...props }) => {

    const [showDialog, setShowDialog] = useState(Boolean(props.openInitially));
    const notify = useNotify();
    const refresh = useRefresh();    
    const translate = useTranslate();  
    const dataProvider = useDataProvider();
    const redirect = useRedirect();
    
    const history = useHistory();
    
    let current_path = history && history.location && history.location.pathname ? history.location.pathname : '';

    const [update, { loading, error }] = useUpdate();

    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
        if (props.onClose) props.onClose();
    };

    const handleSubmit = async values => {
            
        update(
            { 
                type: 'update', 
                resource: 'donations_users', 
                payload : { id: values.id, data : values }
            },
            {
                onSuccess: ({ data }) => {
                    setShowDialog(false);   
                    
                    if (!props.record.donations_projects_payment_systems_fac) { redirect('/donations_users/' + props.donations_projects_id ); refresh(); return; }
                    
                    if (!current_path.includes('/donations_certificates') && !current_path.includes('/donations_transfer_validations'))
                    {
                        redirect('/reports/donations_users/' + props.donations_projects_id );
                    }                    
                    refresh();
                },
                onFailure: ( error ) => {
                    notify(error.message, 'error');
                }
            }
        );
    };    
    
    return (
        <>            
            {!props.hideTrigger ? <Button onClick={handleClick} label={translate('donations_users.edit')}>
              <EditIcon />                
            </Button> : null}

            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label={translate('donations_users.status_form')}
                disableEnforceFocus
            >
                <DialogTitle>{translate('donations_users.edit')}</DialogTitle>

                <FormWithRedirect
                    resource="remittances_users_items"
                    save={handleSubmit}
                    initialValues={{ associations_id: localStorage.getItem('associations_id') , ...props.record }}
                    render={({
                        handleSubmitWithRedirect,
                        pristine,
                        saving
                    }) => (
                        <>
                            <DialogContent>
                              <DonationsUsersForm forceFiscalData={props.forceFiscalData} />
                            </DialogContent>  
                            <DialogActions>
                                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                                    <IconCancel />
                                </Button>
                                <SaveButton
                                    handleSubmitWithRedirect={
                                        handleSubmitWithRedirect
                                    }
                                    pristine={pristine}
                                    saving={saving}
                                    disabled={loading}
                                />
                            </DialogActions>
                        </>
                    )}
                />
            </Dialog>
        </>
    );
}

export const CreateDonationButton = ({ donations_projects_id , ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('donations_users');
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
  const redirect = useRedirect();
        
  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {                    
          setShowDialog(false);
          refresh();        
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };
    
  return (
    <>            
      <Button onClick={handleClick} label={translate('donations_users.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('donations_users.create')}
      >
        <DialogTitle>{translate('donations_users.create')}</DialogTitle>

        <FormWithRedirect
          save={handleSubmit}
          initialValues={{ associations_id: localStorage.getItem('associations_id'), donations_projects_id: donations_projects_id, status: 1, user_type: 0, payment_method: 0, want_certificate: false }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
                            
                <DialogContent>
                  <DonationsUsersForm />
                </DialogContent>              
              
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

export const DonationsUsersForm = ({ ...props }) => {
    const translate = useTranslate();        
    return (<FormDataConsumer>
    {({ formData, ...rest }) => <>
                <Grid container spacing={1}>
                  <Grid item xs={8}>  
                    { props.public ? 
                        <RadioButtonGroupInput source="payment_method" choices={choicesDonationsUsersPublicPaymentMethod(translate)} optionText="name" optionValue="id" label={translate('donations_users.payment_method')}  validate={required()} />            
                    : 
                        <RadioButtonGroupInput source="payment_method" choices={choicesDonationsUsersPaymentMethod(translate)} optionText="name" optionValue="id" label={translate('donations_users.payment_method')}  validate={required()} />            
                    }
                  </Grid>
                  <Grid item xs={4}>                    
                    <NumberInput source="amount" label={translate('donations_users.amount')} parse={value => value ? value : 0 } validate={[required(),validateDoubleGreatZero(translate('common.validation.number'))]} />            
                  </Grid>
                </Grid>
                <Grid container spacing={1}>                  
                  <Grid item xs={12}>                    
                    <RadioButtonGroupInput source="user_type" choices={choicesTypeUser(translate)} optionText="name" optionValue="id" label={translate('donations_users.user_type')}  validate={required()} />            
                  </Grid>
                </Grid>                
                <Grid container spacing={1}>                                     
                  <Grid item xs={formData.user_type == 0 ? 4 : 12}>                                               
                    <TextInput fullWidth source="first_name" label={translate('donations_users.first_name')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                  </Grid>
                  {formData.user_type == 0 ? 
                  <Grid item xs={4}>                                               
                    <TextInput fullWidth source="last_name_1" label={translate('donations_users.last_name_1')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                  </Grid> : null }
                  {formData.user_type == 0 ? 
                  <Grid item xs={4}>                                               
                    <TextInput fullWidth source="last_name_2" label={translate('donations_users.last_name_2')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                  </Grid> : null } 
                </Grid> 
                <Grid container spacing={1}>                                     
                  <Grid item xs={12}>                                               
                    <TextInput fullWidth source="email" label={translate('donations_users.email')} parse={value => value} validate={[validateMaxLength(100,translate('common.validation.maxLength')),validateEmail()]} />
                  </Grid>                  
                </Grid> 
                <Grid container spacing={1}>        
                  <Grid item xs={12}>                                               
                    <BooleanInput fullWidth source="want_certificate" label={translate('donations_users.want_certificate')} />
                  </Grid>
                </Grid>
                {formData.want_certificate || props.forceFiscalData ? 
                <>
                <Grid container spacing={1}>        
                  <Grid item xs={6}>                                               
                    <TextInput fullWidth source="nif" label={translate('donations_users.nif')} validate={[required(),validateMaxLength(15,translate('common.validation.maxLength'))]} />
                  </Grid>
                  <Grid item xs={6}>
                    <TextInput fullWidth source="phone" label={translate('donations_users.phone')} validate={[validateMaxLength(15,translate('common.validation.maxLength'))]} />
                  </Grid>
                  <Grid item xs={6}>
                    <TextInput fullWidth source="address" label={translate('donations_users.address')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                  </Grid>                  
                  <Grid item xs={6}>
                    <TextInput fullWidth source="zip" label={translate('donations_users.zip')} validate={[required(),validateMaxLength(5,translate('common.validation.maxLength'))]} />
                  </Grid>
                  <Grid item xs={6}>
                    <TextInput fullWidth source="city" label={translate('donations_users.city')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                  </Grid>
                  <Grid item xs={6}>
                    <TextInput fullWidth source="country" label={translate('donations_users.country')} validate={[required(),validateMaxLength(50,translate('common.validation.maxLength'))]} />
                  </Grid>
                </Grid> 
                </>
                : null }
                <Grid container spacing={1}>        
                  <Grid item xs={12}>
                    <TextInput fullWidth multiline source="comment" label={translate('donations_users.comment')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />   
                  </Grid>
                </Grid>
              </> }
    </FormDataConsumer>);
        
};

